import { useState } from 'react';

import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';
import { PaymentInterval } from '@/shared/types/Billing';

import { useBilling } from './useBilling';
import { useBuyPlanButton } from './useBuyPlanButton';

type UsePricingCardsControllerParams = {
  defaultPaymentPeriod: PaymentInterval;
  // The trial modal fires its own billing-toggle events; the pricing page keeps the shared ones.
  source?: 'pricingPage' | 'trialModal';
  setChosenPlanId: (chosenPlanId: null | string) => void;
};

export const usePricingCardsController = ({
  defaultPaymentPeriod,
  source = 'pricingPage',
  setChosenPlanId,
}: UsePricingCardsControllerParams) => {
  const { plansGroupByCategory, products } = useBilling();
  const [paymentPeriod, setPaymentPeriod] = useState(defaultPaymentPeriod);
  const { handleBuyPlanButtonClick } = useBuyPlanButton({ paymentPeriod, setChosenPlanId });

  const yearlySelected = paymentPeriod === PaymentInterval.Year;

  const handleToggle = (nextYearlySelected: boolean) => {
    const isTrialModal = source === 'trialModal';
    if (nextYearlySelected) {
      (isTrialModal ? MixpanelEvents.trialPricingModalSwitchAnnual : MixpanelEvents.pricingSwitchAnnual)();
    } else {
      (isTrialModal ? MixpanelEvents.trialPricingModalSwitchMonthly : MixpanelEvents.pricingSwitchMonthly)();
    }
    setPaymentPeriod(nextYearlySelected ? PaymentInterval.Year : PaymentInterval.Month);
  };

  return {
    paymentPeriod,
    plansGroupByCategory,
    products,
    yearlySelected,
    handleBuyPlanButtonClick,
    handleToggle,
  };
};
